import React from 'react'

function EducationCardBody({ instituteName, course, duration, cpi, imageUrl }) {

    const educations = [
        {
            "instituteName": "National Institute Of Technology, Raipur",
            "course": "Master of Computer Applications (MCA)",
            "duration": "2021 - 2023",
            "cpi": "9.25 CPI 🥇",
            "imageUrl": "https://upload.wikimedia.org/wikipedia/en/1/1f/National_Institute_of_Technology%2C_Raipur_Logo.png"
        },
        {
            "instituteName": "KIIT, Bhubaneswar",
            "course": "Bachelors of Computer Applications (BCA)",
            "duration": "2017 - 2020",
            "cpi": "9.9 CGPA 🥇",
            "imageUrl": "https://kiit.ac.in/wp-content/uploads/2022/10/KIIT-logo-HD.png"
        },
        {
            "instituteName": "Vidyasagar Academy, Bargarh",
            "course": "High Secondary Schooling",
            "duration": "2015 - 2017",
            "cpi": "61.2 %",
            "imageUrl": "https://vidyasagarbargarh.org/wp-content/uploads/2023/11/vd-log-e1708497639955.png"
        },
        {
            "instituteName": "Vidyasagar Academy, Bargarh",
            "course": "Secondary Schooling",
            "duration": "2011 - 2015",
            "cpi": "9.6 CGPA",
            "imageUrl": "https://vidyasagarbargarh.org/wp-content/uploads/2023/11/vd-log-e1708497639955.png"
        }
    ];

    return (
        <>
            <div className='json-heading-wrapper'>
                [
                <div className="json-ui">
                    {educations.map((education, index) => (
                        <div key={index} className="json-project">
                            <span>&#123;</span>
                            <div className="json-property">
                                <span className="json-key">"instituteName":</span> <span className="json-value">"{education.instituteName}"</span>,
                            </div>
                            <div className="json-property">
                                <span className="json-key">"course":</span> <span className="json-value">"{education.course}"</span>,
                            </div>
                            <div className="json-property">
                                <span className="json-key">"duration":</span> <span className="json-value">"{education.duration}"</span>,
                            </div>
                            <div className="json-property">
                                <span className="json-key">"cpi":</span> <span className="json-value">"{education.cpi}"</span>,
                            </div>
                            <div className="json-property">
                                <span className="json-key">"logo":</span> <span className="json-value"><img src={education.imageUrl} className='instituteLogo'></img></span>
                            </div>
                            <span>&#125;{index < educations.length - 1 && ","}</span>
                        </div>
                    ))}
                </div>
                ]
            </div>
        </>
    )
}

export default EducationCardBody